import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { POS_CONFIG } from 'state/posConfig/type';
import POSProviderDropdown from './posProvider';
import usePosConfig from 'state/posConfig/hooks/usePosConfig';
import CardReaderInput from './cardReaderSection';

const ExternalConfig = (): JSX.Element => {

  const { toFetchEnabledProviders, posConfig } = usePosConfig();

  const { error, enabledProviders } = posConfig;

  const [selectedProvider, setSelectedProvider] =
    useState<POS_CONFIG.IEnabledProviders>();

  const [saveExternalConfigSuccess, setSaveExternalConfigSuccess] =
    useState(false);

  useEffect(() => {
    toFetchEnabledProviders();
  }, []);

  // Auto-select first provider when enabledProviders is loaded
  useEffect(() => {
    if (enabledProviders?.data && enabledProviders.data.length > 0 && !selectedProvider) {
      setSelectedProvider(enabledProviders.data[0]);
    }
  }, [enabledProviders, selectedProvider]);

  useEffect(() => {
    if (
      error?.fetchEnabledProviders ||
      error?.fetchPosConfig ||
      error?.createPosConfig ||
      error?.updatePosConfig ||
      error?.deletePosConfig
    ) {
      toast.error('Something went wrong! Please try again later.');
    }
  }, [error]);

  useEffect(() => {
    if (saveExternalConfigSuccess) {
      toast.success('API keys have been submitted successfully');
      setSaveExternalConfigSuccess(false);
    }
  }, [saveExternalConfigSuccess]);

  const handleProviderSelect = (provider: POS_CONFIG.IEnabledProviders) => {
    setSelectedProvider(provider);
  };

  return (
    <>
      <POSProviderDropdown
        selectedProvider={selectedProvider}
        onSelectProvider={handleProviderSelect}
      />

      <CardReaderInput
        selectedProvider={selectedProvider}
        setSaveExternalConfigSuccess={setSaveExternalConfigSuccess}
      />
    </>
  );
};

export default ExternalConfig;
